import styles from './footer.module.scss';

import { PUBLIC_BASE_URL_ENV, PUBLIC_CHANNEL } from 'tools/environments';
import { CityCrest, PalermoCrest } from './svg';
import { GetSimpleFooterResponse } from 'services/idm';
import { useTranslation } from 'react-i18next';

export type FooterProps = {
    data?: GetSimpleFooterResponse;
    isLogoDisplayed?: boolean;
};

function getCurrentYear() {
    return new Date().getFullYear().toString();
}

const LogosMap: { [key: string]: typeof CityCrest | typeof PalermoCrest } = {
    mancity: CityCrest,
    palermo: PalermoCrest,
};

const getLogoByClub = (name: string) => {
    const Component = LogosMap[name.toLowerCase()];
    return Component ? <Component /> : <></>;
};

const ClubText: { [key: string]: string } = {
    mancity: 'Manchester City FC',
    palermo: 'Palermo F.C.',
};

export function SimpleFooter({ data, isLogoDisplayed = false }: FooterProps) {
    const theme = PUBLIC_CHANNEL || 'mancity';
    const { t } = useTranslation();
    return (
        <footer className={styles['simple-footer']}>
            <div className={styles['logo-section']}>
                <div className={styles['logo-wrapper']}>
                    {isLogoDisplayed && (
                        <a
                            href={PUBLIC_BASE_URL_ENV}
                            className={styles['logo']}
                            aria-label={ClubText[theme]}
                            title={ClubText[theme]}
                        >
                            {getLogoByClub(theme)}
                        </a>
                    )}

                    <p className={`body-small bold`}>
                        {t('common.footer_copyright')
                            .replace('{siteName}', ClubText[theme])
                            .replace('{year}', getCurrentYear())}
                    </p>
                </div>
            </div>
            <div className={styles['nav-section']}>
                {data && (
                    <ul className={styles['nav-list']}>
                        {data.map((list, index) => (
                            <li key={index}>
                                <a
                                    className={`body-small ${styles['nav-list-link']}`}
                                    href={list.url}
                                    target={list.target || '_self'}
                                >
                                    {list.name[0].toUpperCase() +
                                        list.name.slice(1).toLowerCase()}
                                </a>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </footer>
    );
}

export default SimpleFooter;
